import React, { useEffect, useState } from "react";

const PointOfContact = (props) => {
  const isEditMode = props?.urlparams?.params?.bankId?.length > 0;
  const [errorMessage, setErrorMessage] = useState({ name: "", message: "" });
  const [fields, setFields] = useState([
    {
      name: "contactPersonName",
      label: "Name",
      type: "text",
      required: true,
    },
    {
      name: "contactPersonMobile",
      label: "Mobile No.",
      type: "text",
      required: true,
    },
  ]);

  const handleMobileNo = (e) => {
    const numberReg = _enum?.REGEX?.number;
    const fieldValue = e.target.value;
    if (numberReg.test(fieldValue) && fieldValue.length === 10) {
      setErrorMessage({ name: "", message: "" });
    } else {
      setErrorMessage({
        name: "contactPersonMobile",
        message: "Please enter a valid Mobile Number",
      });
    }
  };

  const handleSubmit = (e, data) => {
    let payload = {
      ...data,
      contactPersonMobile: data.contactPersonMobile,
    };
    console.log(payload, props.selectedBank?.bankId);

    let bankId;
    if (isEditMode) {
      bankId = props?.urlparams?.params?.bankId;
    } else {
      bankId = props.selectedBank?.bankId;
    }
    props.apis
      .apiUpdateBankOffer(payload, {
        bankId: bankId,
      })
      .then((res) => {
        if (res) {
          props.changeTab(e, "uploadeddocs");
        }
      });
  };

  const updateFields = (fields, data) => {
    let result = fields?.map((field) => {
      console.log({ field });
      if (field.type === "file") {
        console.log({ data, field });
        field.defaultValue = data[field.name];
        field.value = data[field.name];
        // field.disabled = true;
        return {
          ...field,
        };
      } else {
        return {
          ...field,
          defaultValue: data[field?.name],
          // disabled: true,
        };
      }
    });
    return result;
  };

  useEffect(() => {
    if (isEditMode) {
      let payload = {
        bankId: props?.urlparams?.params?.bankId,
      };
      props.apis.apiGetBankOfferById(payload).then((res) => {
        if (res) {
          let updatedFields = updateFields(fields, res);
          setFields([...updatedFields]);
        }
      });
    }
  }, []);
  return (
    <>
      <AppForm className="container" onSubmit={handleSubmit}>
        {fields?.map((field, i) => {
          return (
            <div
              className={`col-12 col-md-${field?.customcolspan || 4}`}
              key={i}
            >
              <AppInput {...field}></AppInput>
            </div>
          );
        })}
        {/* <div className="col-12 col-md-4">
          <AppInput
            name="contactPersonName"
            label="Name"
            type="text"
            required={true}
          ></AppInput>
        </div>
        <div className="col-12 col-md-4">
          <AppInput
            outerclass="m-0"
            name="contactPersonMobile"
            label="Mobile No."
            type="number"
            required={true}
            onChange={(...args) => handleMobileNo(...args)}
          ></AppInput>
          {errorMessage.name === "contactPersonMobile" && (
            <p className="text-danger">{errorMessage.message}</p>
          )}
        </div> */}
        <div className="nav_container text-end mt-4">
          <button
            type="button"
            className="formdata-cancel-btn btn"
            onClick={(...args) => props.changeTab(...args, "docsrequired")}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary ms-3"
            // disabled={errorMessage.message.length > 0 ? true : false}
          >
            {isEditMode ? "Update" : "Submit"}
          </button>
        </div>
      </AppForm>
    </>
  );
};

export default constore(PointOfContact);
